module.exports = __webpack_public_path__ + "assets/img/img-map-fukuoka-sp.9d7ca3f5.svg";